var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("nav", [
      _c(
        "ul",
        {
          staticClass:
            "nav navbar justify-content-between align-items-center bg-white"
        },
        [
          _c("li", { staticClass: "nav-item" }, [
            _c("a", { attrs: { href: "https://hungerhub.com/", id: "logo" } }, [
              _c("img", {
                staticClass: "logo d-sm-block mx-auto",
                attrs: {
                  src: require("../assets/img/uncatering_logo.png"),
                  alt: "Uncatering",
                  "text-align": "center",
                  "data-retina": "true"
                }
              })
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { attrs: { id: "preloader" } }, [
        _c(
          "div",
          {
            staticClass: "sk-spinner sk-spinner-wave",
            attrs: { id: "status" }
          },
          [
            _c("div", { staticClass: "sk-rect1" }),
            _vm._v(" "),
            _c("div", { staticClass: "sk-rect2" }),
            _vm._v(" "),
            _c("div", { staticClass: "sk-rect3" }),
            _vm._v(" "),
            _c("div", { staticClass: "sk-rect4" }),
            _vm._v(" "),
            _c("div", { staticClass: "sk-rect5" })
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61dd7a3d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61dd7a3d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = null
// module chunks = 